
























































































import { GetFileServiceUrl } from "@/helper/uploadHelper";
import { Component, Vue, Watch } from "vue-property-decorator";
import {  MerchantId } from "@/helper/userHelper";

@Component
export default class ModalLinePEAKConnect extends Vue {
  private showModal = true;
  private GetFileServiceUrl = GetFileServiceUrl;
  private activePageIndex = 0;

  @Watch("showModal")
  showModalChanged(newVal: boolean) {
    if (!newVal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }

  get canGoBack() {
    return this.activePageIndex !== 0;
  }

  get canGoNext() {
    return this.activePageIndex < 3;
  }

  public Back() {
    this.activePageIndex--;
  }

  public Next() {
    this.activePageIndex++;
  }

  public LinkToFileVault() {
    window.open(`${process.env.VUE_APP_PeakAccount}document/uploadDocument?emi=${MerchantId().PeakEncryption()}`);
  }
}
